export const SB = [
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/617adqEx3rL._UL1500_-400x400.jpg",
    title: "FINACHI Ultra Soft Inner Boxer Black",
    price: 325,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-10-15-at-10.29.59-AM-1-400x544.jpeg",
    title: "pure cotton men’s printed shirt ",
    price: 895,
    offer: "-44%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-10-15-at-10.30.00-AM-400x591.jpeg",
    title: "pure cotton men’s printed shirt ",
    price: 895,
    offer: "-44%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-10-15-at-10.29.57-AM-400x600.jpeg",
    title: "pure cotton men’s printed shirt ",
    price: 805,
    offer: "-40%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-10-15-at-10.29.58-AM-400x539.jpeg",
    title: "pure cotton men’s printed shirt ",
    price: 805,
    offer: "-40%",
  },

  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-23-at-1.02.06-PM-400x493.jpeg",
    title: "pure cotton men’s printed shirt ",
    price: 805,
    offer: "-40%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-23-at-1.02.05-PM-1-400x491.jpeg",
    title: "pure cotton men’s printed shirt ",
    price: 805,
    offer: "-40%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-23-at-1.02.05-PM-400x497.jpeg",
    title: "pure cotton men’s printed shirt ",
    price: 805,
    offer: "-40%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-23-at-1.02.04-PM-2-400x396.jpeg",
    title: "pure cotton men’s printed shirt ",
    price: 805,
    offer: "-40%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-23-at-1.02.04-PM-1-400x493.jpeg",
    title: "pure cotton men’s printed shirt ",
    price: 805,
    offer: "-40%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-23-at-1.02.04-PM-400x498.jpeg",
    title: "pure cotton men’s printed shirt ",
    price: 805,
    offer: "-40%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-10-15-at-10.29.59-AM1-400x600.jpeg",
    title: "pure cotton men’s printed shirt ",
    price: 805,
    offer: "-40%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-10-15-at-10.29.58-AM-1-400x593.jpeg",
    title: "pure cotton men’s printed shirt ",
    price: 805,
    offer: "-40%",
  },
];
export const shirt = [
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-27-at-11.47.57-AM-400x600.jpeg",
    title: "Rubi cotton With digital print Half ",
    price: 795,
    offer: "-34%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/08/374f71cb-67ad-4c87-9f46-061b9d2ac6a6-400x539.jpg",
    title: "MEN SHIRT Magic cotton With digital ",
    price: 795,
    offer: "-34%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-27-at-11.47.57-AM-1-400x600.jpeg",
    title: "Rubi cotton With digital print Half. ",
    price: 795,
    offer: "-34%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-27-at-11.47.58-AM-400x600.jpeg",
    title: "Rubi cotton With digital print Half ",
    price: 795,
    offer: "-34%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-27-at-11.47.58-AM-1-400x600.jpeg",
    title: "Rubi cotton With digital print Half ",
    price: 795,
    offer: "-34%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-27-at-11.47.59-AM-400x601.jpeg",
    title: "Rubi cotton With digital print Half ",
    price: 795,
    offer: "-34%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-27-at-11.47.59-AM-1-400x600.jpeg",
    title: "Rubi cotton With digital print Half ",
    price: 795,
    offer: "-34%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-27-at-11.48.00-AM-400x600.jpeg",
    title: "Rubi cotton With digital print Half ",
    price: 795,
    offer: "-34%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-27-at-11.48.00-AM-1-400x513.jpeg",
    title: "Rubi cotton With digital print Half ",
    price: 795,
    offer: "-34%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-27-at-11.48.01-AM-400x600.jpeg",
    title: "Rubi cotton With digital print Half ",
    price: 795,
    offer: "-34%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-27-at-11.48.01-AM1-400x556.jpeg",
    title: "Rubi cotton With digital print Half ",
    price: 795,
    offer: "-34%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/WhatsApp-Image-2022-02-07-at-6.29.41-PM-400x600.jpeg",
    title: "Rubi cotton With digital print Half ",
    price: 795,
    offer: "-34%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2021/10/WhatsApp-Image-2021-09-27-at-11.48.03-AM-400x513.jpeg",
    title: "Rubi cotton With digital print Half ",
    price: 795,
    offer: "-34%",
  },
];
export const Tshirts = [
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/51mRO9X8L._UL1000_-400x400.jpg",
    title: "FINACHI Premium Cotton T-Shirts Combo",
    price: 990,
    offer: "-24%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/51mRO9X8L._UL1000_-400x400.jpg",
    title: "FINACHI Premium Cotton T-Shirts Combo",
    price: 990,
    offer: "-24%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/51mRO9X8L._UL1000_-400x400.jpg",
    title: "FINACHI Premium Cotton T-Shirts Combo",
    price: 990,
    offer: "-24%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/51mRO9X8L._UL1000_-400x400.jpg",
    title: "FINACHI Premium Cotton T-Shirts Combo",
    price: 990,
    offer: "-24%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/61-Qz6jP4QL._UL1000_-400x400.jpg",
    title: "FINACHI Vest Combo",
    price: 990,
    offer: "-14%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/41tpscFGC8L._UL1000_-400x400.jpg",
    title: "FINACHI Premium Cotton T-Shirt (Black)",
    price: 399,
    offer: "-24%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/41xl2-xcHoL._UL1000_-1-400x400.jpg",
    title: "FINACHI Premium Cotton T-Shirt (Dark Blue)",
    price: 399,
    offer: "-24%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/51s-EmuOnnL._UL1000_-1-400x400.jpg",
    title: "FINACHI Premium Cotton T-Shirt (Peach Color)",
    price: 399,
    offer: "-24%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/519oLttxcZL._UL1000_-3-400x400.jpg",
    title: "FINACHI Premium Cotton T-Shirt (Pista)",
    price: 399,
    offer: "-54%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/618gZB8DiKL._UL1500_-400x400.jpg",
    title: "FINACHI Ultra Soft T-Shirt black",
    price: 990,
    offer: "-54%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/61nB1ZuhBCL._UL1500_.jpg",
    title: "FINACHI Premium Cotton T-Shirts Combo",
    price: 990,
    offer: "-24%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/61IZ6ATVMFL._UL1500_-400x400.jpg",
    title: "FINACHI Premium Cotton T-Shirts Combo",
    price: 990,
    offer: "-24%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/61wHli5TQuL._UL1500_-400x400.jpg",
    title: "FINACHI Premium Cotton T-Shirts Combo",
    price: 990,
    offer: "-24%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/51mRO9X8L._UL1000_-400x400.jpg",
    title: "FINACHI Premium Cotton T-Shirts Combo",
    price: 990,
    offer: "-24%",
  },
];

export const TB = [
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/61uFAIVjljL._UL1500_-400x399.jpg",
    title: "FINACHI 100% Combed Bio Wash Cotton",
    price: 799,
    offer: "-47%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/61rewJs4pFL._UL1500_-400x399.jpg",
    title: "FINACHI 100% Combed Bio Wash Cotton",
    price: 799,
    offer: "-47%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/81OXF5PEo8L._UL1500_-400x400.jpg",
    title: "FINACHI Ultra Soft Cotton Brief (Pack)",
    price: 799,
    offer: "-47%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/81BoaL5NdHL._UL1500_-400x400.jpg",
    title: "FINACHI Ultra Soft Cotton Brief (Pack)",
    price: 799,
    offer: "-47%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/61mqFWGAmQL._UL1500_-400x399.jpg",
    title: "FINACHI 100% Combed Bio Wash Cotton.",
    price: 499,
    offer: "-40%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/61rzcvHQDTL._UL1500_-400x399.jpg",
    title: "FINACHI 100% Combed Bio Wash Cotton.",
    price: 499,
    offer: "-40%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/518vKyF4xL._UL1000_-400x400.jpg",
    title: "FINACHI Ultra Soft Modal Brief (Pack).",
    price: 549,
    offer: "-40%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/514CuQ8DsaL._UL1000_-400x400.jpg",
    title: "FINACHI Ultra Soft Modal Brief (Pack).",
    price: 549,
    offer: "-40%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/51O73PXl2SL._UL1000_-400x400.jpg",
    title: "FINACHI Ultra Soft Modal Trunk (Pack...",
    price: 649,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/51D0eXpOuNL._UL1000_-400x400.jpg",
    title: "FINACHI Ultra Soft Modal Trunk (Pack...",
    price: 649,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/513eZSzsvbL._UL1000_-400x400.jpg",
    title: "FINACHI Ultra Soft Modal Trunk (Pack...",
    price: 649,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/51c77FDveJL._UL1000_-400x400.jpg",
    title: "FINACHI Ultra Soft Modal Trunk (Pack...",
    price: 649,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/51Zhp6D5w9L._UL1000_-400x400.jpg",
    title: "FINACHI Ultra Soft Modal Trunk (Pack...",
    price: 649,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/61r-h13dJqL._UL1500_-400x399.jpg",
    title: "FINACHI 100% Combed Bio Wash Cotton...",
    price: 649,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/02/51ZALmsvn7L._UL1000_-400x400.jpg",
    title: "FINACHI Ultra Soft Modal Trunk (Pack...",
    price: 449,
    offer: "-44%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/61r-h13dJqL._UL1500_-400x399.jpg",
    title: "FINACHI Ultra Soft Modal Trunk (Pack...",
    price: 449,
    offer: "-44%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/51rcWWWF7aL._UL1500_-400x399.jpg",
    title: "FINACHI Ultra Soft Modal Trunk (Pack...",
    price: 449,
    offer: "-44%",
  },
];
export const Lahnga = [
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/071-400x562.jpg",
    title: "mint green anarkali set ",
    price: 5599,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/181.jpg",
    title: "2 piece jacket dress set",
    price: 2799,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/101.jpg",
    title: "aquamarine cotton suit set ",
    price: 2899,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/456.jpg",
    title: "bandhej dhoti set",
    price: 2899,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/216-400x563.jpg",
    title: "berry blue cotton suit set ",
    price: 2599,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/415.jpg",
    title: "black crown sharara set ",
    price: 3599,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/320-400x587.jpg",
    title: "black polka set",
    price: 1999,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/225-400x580.jpg",
    title: "blue anchor cotton suit set",
    price: 2399,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/053-400x460.jpg",
    title: "mint green anarkali set ",
    price: 2999,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/272-400x583.jpg",
    title: "Buff Orange Cotton Suit Set ",
    price: 5599,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/154.jpg",
    title: "mint green anarkali set ",
    price: 4599,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/451-400x556.jpg",
    title: "calico print drape set ",
    price: 3599,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/058-400x566.jpg",
    title: "cherry red suit set",
    price: 3599,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/316-400x583.jpg",
    title: "chevron kurti set ",
    price: 3599,
    offer: "-17%",
  },
];
export const Patola = [
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/100MI-D-549.png",
    title: "Adorable Amaze Faux Crepe Printed Short...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/025MI-D-535.png",
    title: "Blend Well Beautiful Blue Faux Crepe...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/100MI-D-549.png",
    title: "Adorable Amaze Faux Crepe Printed Short...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/148MI-D-558.png",
    title: "Blue Summer Cool Short Kurti Tunic...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/077MI-D-545.png",
    title: "Bright as Summer Cool Printed Short...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/154.jpg",
    title: "mint green anarkali set ",
    price: 4599,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/451-400x556.jpg",
    title: "calico print drape set ",
    price: 3599,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/058-400x566.jpg",
    title: "cherry red suit set",
    price: 3599,
    offer: "-17%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/03/316-400x583.jpg",
    title: "chevron kurti set ",
    price: 3599,
    offer: "-17%",
  },
];
export const Tunic = [
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/071MI-D-544.png",
    title: "Admirable Mehendi Green Summer Cool Printed...",
    price: 599,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/100MI-D-549.png",
    title: "Adorable Amaze Faux Crepe Printed Short...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/112MI-D-552.png",
    title: "Alluring Faux Crepe Printed Short Kurti...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/001MI-D-531.png",
    title: "Alluring Faux Crepe Printed Short Kurti...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/164MI-D-562.png",
    title: "Ash Gray Faux Crepe Beautiful Short...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/174MI-D-564.png",
    title: "Ash Gray Faux Crepe Short Kurti...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/059MI-D-542.png",
    title: "Befitting Brigade Cool Printed Short Kurti...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/106MI-D-551.png",
    title: "Best Stylish Faux Crepe Printed Short...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/100MI-D-549.png",
    title: "Adorable Amaze Faux Crepe Printed Short...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/025MI-D-535.png",
    title: "Blend Well Beautiful Blue Faux Crepe...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/100MI-D-549.png",
    title: "Adorable Amaze Faux Crepe Printed Short...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/148MI-D-558.png",
    title: "Blue Summer Cool Short Kurti Tunic...",
    price: 595,
    offer: "-57%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/01/077MI-D-545.png",
    title: "Bright as Summer Cool Printed Short...",
    price: 595,
    offer: "-57%",
  },
];
export const Fabric = [
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/04/WhatsApp-Image-2022-04-25-at-12.48.22-PM-400x499.jpeg",
    title: "Fancy pallu thread & sequnce work...",
    price: 2697,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/04/WhatsApp-Image-2022-04-20-at-6.33.05-PM-1-400x500.jpeg",
    title: "Fancy ruffle & sequnce work with...",
    price: 2697,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/04/WhatsApp-Image-2022-04-20-at-6.33.19-PM-1-400x500.jpeg",
    title: "Havy dola silk digital print saree",
    price: 1500,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/04/WhatsApp-Image-2022-04-20-at-6.51.18-PM-2-400x500.jpeg",
    title: "Havy japan silk digital print saree",
    price: 2550,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/04/WhatsApp-Image-2022-04-20-at-6.33.19-PM-1-400x500.jpeg",
    title: "Heavy butter silk with digital print...",
    price: 2697,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/04/WhatsApp-Image-2022-04-16-at-10.48.22-PM-400x471.jpeg",
    title: "pallu & jacquard work in black...",
    price: 1349,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/04/WhatsApp-Image-2022-04-15-at-11.59.33-AM-400x484.jpeg",
    title: "pallu & jacquard work in black...",
    price: 1799,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/04/WhatsApp-Image-2022-04-16-at-5.52.20-PM-3-400x575.jpeg",
    title: "pallu & jacquard work in black...",
    price: 1289,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/04/WhatsApp-Image-2022-04-15-at-11.58.07-AM-1-400x499.jpeg",
    title: "pallu & jacquard work in black...",
    price: 1440,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/04/WhatsApp-Image-2022-04-15-at-11.59.55-AM-400x600.jpeg",
    title: "pallu & jacquard work in black...",
    price: 1799,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/04/WhatsApp-Image-2022-04-16-at-10.48.24-PM-400x465.jpeg",
    title: "pallu & jacquard work in blue...",
    price: 1349,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/04/WhatsApp-Image-2022-04-15-at-12.00.15-PM-400x500.jpeg",
    title: "pallu & jacquard work in blue...",
    price: 1799,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/04/WhatsApp-Image-2022-04-15-at-12.00.15-PM-400x500.jpeg",
    title: "pallu & jacquard work in blue..",
    price: 1779,
    offer: "-50%",
  },
  {
    img: "https://www.uboric.com/wp-content/uploads/2022/04/WhatsApp-Image-2022-04-16-at-10.48.22-PM-2-400x500.jpeg",
    title: "pallu & jacquard work in brown...",
    price: 1349,
    offer: "-50%",
  },
];
